// extracted by mini-css-extract-plugin
export default {"container":"confirmPayment_container__+QrBV","title":"confirmPayment_title__xdZJd","subtitle":"confirmPayment_subtitle__SEqUS","info":"confirmPayment_info__Kownw"};